import useArchiveInboundEmail from '@/api/mutations/inbound-emails/useArchiveInboundEmail';
import { ArchiveInboundEmailMutation } from '@/gql/graphql';
import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { createOptimisticMutationOptions } from './createOptimisticMutation';
import {
  applyDetailOptimisticArchive,
  applyOptimisticArchive,
} from './optimisticUpdates';

const useOptimisticArchiveInboundEmail = (
  options?: UseMutationOptions<
    ArchiveInboundEmailMutation,
    unknown,
    { inboundEmailId: string }
  >
) => {
  const queryClient = useQueryClient();

  const optimistic = createOptimisticMutationOptions(
    queryClient,
    {
      applyToInbox: (data, vars) => applyOptimisticArchive(data, vars),
      applyToDetail: (data) => applyDetailOptimisticArchive(data),
      tracksUnreadCount: true,
    },
    options
  );

  return useArchiveInboundEmail({ ...options, ...optimistic });
};

export default useOptimisticArchiveInboundEmail;
